/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, centerAbsolutely, fullSize, answerSelect } from 'utils/styles/style_helpers';



/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// BACKGROUND STYLES
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
export default theme => ({
	background: {
		borderRadius: 'inherit',
		extend: [centerAbsolutely, fullSize, answerSelect],
		zIndex: '1',
		cursor: 'pointer',
		'& .fade': {
			borderRadius: 'inherit',
			extend: [centerAbsolutely, fullSize],
			zIndex: '2',
			// background color comes from component itself dynamically
			// helpful gradient generator below
			// http://angrytools.com/gradient/
			// background: "radial-gradient(ellipse at center, rgba(82,83,84,0.65) 0%, rgba(0,10,10,0.7) 100%)" /* w3c */
		},
		'& .image': {
			borderRadius: 'inherit',
			transition: 'background-image .2s linear 0s',
			extend: [centerAbsolutely, fullSize],
			zIndex: '1',
			// backgroundColor: '#000',
			backgroundPosition: '50% 50%',
			backgroundRepeat: 'no-repeat',
			backgroundSize: 'cover'
			// backgroundImage added dynamically as inline style from component file which pulls it from content data
		},
		'& .imageindicator': {
			position: 'absolute',
			bottom: pxToEm(10),
			left: pxToEm(10),
		}
	}
});